<template>
  <div>
    <div ref="mountEl"></div>
  </div>
</template>
<script src="./vimeo-player.js"></script>
